"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaletteContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PaletteContext = (0, _react.createContext)('light');
exports.PaletteContext = PaletteContext;

var PaletteProvider = function PaletteProvider(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'light' : _props$variant,
      children = props.children;
  return (0, _core.jsx)(PaletteContext.Provider, {
    value: variant
  }, children);
};

var _default = PaletteProvider;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PaletteContext, "PaletteContext", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/index.tsx");
  reactHotLoader.register(PaletteProvider, "PaletteProvider", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/PaletteProvider/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdHlsZXMvUGFsZXR0ZVByb3ZpZGVyL2luZGV4LnRzeCJdLCJuYW1lcyI6WyJQYWxldHRlQ29udGV4dCIsIlBhbGV0dGVQcm92aWRlciIsInByb3BzIiwidmFyaWFudCIsImNoaWxkcmVuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUlPLElBQU1BLGNBQWMsR0FBRywwQkFBMkIsT0FBM0IsQ0FBdkI7OztBQU1QLElBQU1DLGVBQXdELEdBQUcsU0FBM0RBLGVBQTJELENBQUNDLEtBQUQsRUFBVztBQUFBLHVCQUNsQ0EsS0FEa0MsQ0FDbEVDLE9BRGtFO0FBQUEsTUFDbEVBLE9BRGtFLCtCQUN4RCxPQUR3RDtBQUFBLE1BQy9DQyxRQUQrQyxHQUNsQ0YsS0FEa0MsQ0FDL0NFLFFBRCtDO0FBRzFFLFNBQU8sZUFBQyxjQUFELENBQWdCLFFBQWhCO0FBQXlCLElBQUEsS0FBSyxFQUFFRDtBQUFoQyxLQUEwQ0MsUUFBMUMsQ0FBUDtBQUNELENBSkQ7O2VBTWVILGU7Ozs7Ozs7Ozs7OzswQkFaRkQsYzswQkFNUEMsZSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBjcmVhdGVDb250ZXh0LCBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IHR5cGUgUGFsZXR0ZVR5cGUgPSAncHJpbWFyeScgfCAnc2Vjb25kYXJ5JyB8ICdsaWdodCcgfCAnZGFyayc7XG5cbmV4cG9ydCBjb25zdCBQYWxldHRlQ29udGV4dCA9IGNyZWF0ZUNvbnRleHQ8UGFsZXR0ZVR5cGU+KCdsaWdodCcpO1xuXG5leHBvcnQgdHlwZSBQYWxldHRlUHJvdmlkZXJQcm9wcyA9IHtcbiAgdmFyaWFudD86IFBhbGV0dGVUeXBlO1xufTtcblxuY29uc3QgUGFsZXR0ZVByb3ZpZGVyOiBGdW5jdGlvbkNvbXBvbmVudDxQYWxldHRlUHJvdmlkZXJQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyB2YXJpYW50ID0gJ2xpZ2h0JywgY2hpbGRyZW4gfSA9IHByb3BzO1xuXG4gIHJldHVybiA8UGFsZXR0ZUNvbnRleHQuUHJvdmlkZXIgdmFsdWU9e3ZhcmlhbnR9PntjaGlsZHJlbn08L1BhbGV0dGVDb250ZXh0LlByb3ZpZGVyPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBhbGV0dGVQcm92aWRlcjtcbiJdfQ==